module.exports = __webpack_public_path__ + "static/media/4.aa3cddb9.jpg";